export default "__VITE_ASSET__DoZ8fxW___"